import styled from 'styled-components'

export const Svg = styled.svg`
  & path {
    fill: ${({ theme }) => theme.colors.backgroundLoggedOut};
  }
`
